'use strict';

exports.__esModule = true;

var _DynamicFieldSelector = require('./DynamicFieldSelector');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DynamicFieldSelector).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];